<template>
    <div>
        <pxkeji-rightHeader/>

        <div class="pxkeji-right-box">
          <a-form :form="form" @submit="handleSubmit">
            <a-table
                    :columns="list.columns"
                    rowKey="id"
                    :dataSource="list.datas"
                    :locale="{emptyText:'暂无数据'}"
                    :loading="isloading"
                    :pagination="list.pagination"
                    @change="onChange"
            >
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="修改价格" size="small" @click="showInfo(action.id)" type="primary"/>
        </span>
            </a-table>
            <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
              <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            </a-form-item>
          </a-form>
        </div>

        <a-modal
                :title="info.title"
                v-model="info.visible"
                width="50%"
                :footer="false"
                destroyOnClose
                :maskClosable="false"
        >
            <Info @callbackMethod="save" :id="info.id"/>
        </a-modal>
    </div>
</template>
<script>
    import Info from "./courseTypePriceInfo.vue"; //编辑

    var that;
    var columns = [
        {
            dataIndex: "name",
            key: "name",
            align: "left",
            title: "名称"
        },
        {
            dataIndex: "price",
            key: "price",
            align: "left",
            title: "价格/元1学时"
        },
        {
            key: "action",
            align: "center",
            title: "操作",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "coursePriceSetting",
        data() {
            return {
                expand: false, //高级搜索
                list: {
                    columns, //表头
                    datas: [
                        {
                            price: 0.00
                        }
                    ], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10 //页容
                    }
                },
                isloading: false,
                info: {
                    title: "",
                    visible: false,
                    id: 0
                }
            };
        },
        components: {
            Info
        },
        mounted: function () {
            this.$nextTick(function () {
                that = this;
                this.GetList();
            });
        },
        watch: {
            selectRows: function () {
                //console.log("watch", val);
            }
        },
        methods: {
            GetList() {
                //获取列表
                this.isloading = true;
                this.$api.courseType
                    .getTreeByColumnId('', '')
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.list.datas = res.data;

                        } else {
                            that.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
          handleSubmit(e){
            e.preventDefault();
            this.$emit("callbackMethod",this.list.datas);
          },
            onChange(page) {
                //页面切换回调
                this.list.pagination.current = page.current;
                this.GetList();
            },
            //查看订单
            showInfo(id) {
                this.info.title = id ? "编辑" : "新增";
                this.info.visible = true;
                this.info.id = id;
            },

            //子组件传值
            save(price, id) {
                this.info.visible = false;
                this.judgedata(this.list.datas, id, price);
            },
            //
            judgedata(item, id, price) {
                for (let itemKey in item) {
                    if (item[itemKey].id === id) {
                        var data = [];
                        data.push(item[itemKey])
                        this.setprice(data, price, id)
                        return;
                    } else if (item[itemKey].children && item[itemKey].children.length > 0) {
                        this.judgedata(item[itemKey].children, id, price)
                    }
                }
            },
            // setprice(item, price,id) {
            //   for (let i = 0; i <item.length ; i++) {
            //
            //     if(item[i].id==id||item[i].parentId==id){
            //       item[i].price=price;
            //     }
            //     if(item[i].children.length>0){
            //       this.setprice(item[i].children,price,item[i].id)
            //     }
            //
            //   }
            //
            // },
            setprice(item, price, id) {
                for (let i = 0; i < item.length; i++) {
                    item[i].price = price;
                    if (item[i].children && item[i].children.length > 0) {
                        this.setprice(item[i].children, price, id)
                    }

                }
            },


        }
    };
</script>

<style>
    .ant-advanced-search-form .ant-form-item {
        display: flex;
    }

    .ant-advanced-search-form .ant-form-item-control-wrapper {
        flex: 1;
    }

    #components-form-demo-advanced-search .ant-form {
        max-width: none;
    }

    #components-form-demo-advanced-search .search-result-list {
        margin-top: 16px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #fafafa;
        min-height: 200px;
        text-align: center;
        padding-top: 80px;
    }

    .cang_sta {
        text-align: center;
    }

    .cang_sta img {
        width: 35px;
    }
</style>

